import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconSpeakerMute$1 = /*@__PURE__*/ proxyCustomElement(class WppIconSpeakerMute extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-speaker-mute", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { d: "M10.7356 3.05442C11.3804 2.48108 12.4 2.93886 12.4 3.80176V16.1982C12.4 17.0612 11.3804 17.5189 10.7355 16.9455L7.14234 13.7506C7.0325 13.6529 6.89063 13.599 6.74365 13.599H3.8C2.80589 13.599 2 12.7931 2 11.799V8.20063C2 7.20651 2.80589 6.40063 3.8 6.40063H6.74369C6.89066 6.40063 7.03252 6.34668 7.14235 6.24903L10.7356 3.05442ZM11.2 4.24719L7.93968 7.14584C7.61017 7.4388 7.1846 7.60063 6.74369 7.60063H3.8C3.46863 7.60063 3.2 7.86926 3.2 8.20063V11.799C3.2 12.1303 3.46863 12.399 3.8 12.399H6.74365C7.1846 12.399 7.6102 12.5608 7.93972 12.8538L11.2 15.7528V4.24719ZM13.3757 7.77751C13.6101 7.54319 13.99 7.54319 14.2243 7.77751L15.6 9.15324L16.9757 7.77751C17.2101 7.54319 17.5899 7.54319 17.8243 7.77751C18.0586 8.01182 18.0586 8.39172 17.8243 8.62604L16.4485 10.0018L17.8243 11.3775C18.0586 11.6118 18.0586 11.9917 17.8243 12.226C17.5899 12.4603 17.2101 12.4603 16.9757 12.226L15.6 10.8503L14.2243 12.226C13.9899 12.4603 13.6101 12.4603 13.3757 12.226C13.1414 11.9917 13.1414 11.6118 13.3757 11.3775L14.7515 10.0018L13.3757 8.62604C13.1414 8.39172 13.1414 8.01182 13.3757 7.77751Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-speaker-mute-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-speaker-mute", "wpp-icon-speaker-mute-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-speaker-mute-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-speaker-mute-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconSpeakerMute$1);
      }
      break;
  } });
}

const WppIconSpeakerMute = WppIconSpeakerMute$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconSpeakerMute, defineCustomElement };
